import apiService from './api';
import { PurchaseStock, CreatePurchaseStockData, UpdatePurchaseStockData } from '../types/purchaseTypes';

class PurchaseService {
  async getPurchaseStock(productId?: string): Promise<PurchaseStock[]> {
    const url = productId ? `/purchase?product_id=${productId}` : '/purchase';
    const response = await apiService.get<PurchaseStock[]>(url);
    return response.data;
  }

  async createPurchaseStock(data: CreatePurchaseStockData): Promise<PurchaseStock> {
    const response = await apiService.post<PurchaseStock>('/purchase', data);
    return response.data;
  }

  async updatePurchaseStock(data: UpdatePurchaseStockData): Promise<PurchaseStock> {
    const { id, ...updateData } = data;
    const response = await apiService.put<PurchaseStock>(`/purchase/${id}`, updateData);
    return response.data;
  }

  async deletePurchaseStock(id: string): Promise<void> {
    await apiService.delete(`/purchase/${id}`);
  }
}

export const purchaseService = new PurchaseService();
export default purchaseService;